import BaseServices from "./BaseServices";

const EmbroideryServices = {
    //#region Máy thêu
    GetMachines: async (paging) => {
        return BaseServices.Post(`/api/Embroidery/get-machines`, paging);
    },
    GetMachineById: async (id) => {
        return BaseServices.Get(`/api/Embroidery/get-machine/${id}`);
    },
    CreateUpdateMachine: async (model) => {
        return BaseServices.Post(`/api/Embroidery/create-update-machine`, model);
    },
    DeleteMachine: async (id) => {
        return BaseServices.Post(`/api/Embroidery/delete-machine/${id}`);
    },
    //#endregion

    //#region Kim - needle bar
    GetNeedleBarsByMachineId: async (machineId) => {
        return BaseServices.Get(`/api/Embroidery/get-needle-bars/${machineId}`);
    },
    SaveNeedleBars: async (machineId, needleBars) => {
        return BaseServices.Post(`/api/Embroidery/save-needle-bars/${machineId}`, needleBars);
    },
    GetNeedleColorGroups: async () => {
        return BaseServices.Get(`/api/Embroidery/get-needle-color-groups`);
    },
    //#endregion

    //#region Họa tiết thêu (pattern)
    GetPatterns: async (paging) => {
        return BaseServices.Post(`/api/Embroidery/get-patterns`, paging);
    },
    GetPatternById: async (id) => {
        return BaseServices.Get(`/api/Embroidery/get-pattern/${id}`);
    },
    CreateUpdatePattern: async (model) => {
        return BaseServices.Post(`/api/Embroidery/create-update-pattern`, model);
    },
    DeletePattern: async (id) => {
        return BaseServices.Post(`/api/Embroidery/delete-pattern/${id}`);
    },
    //#endregion
};

export default EmbroideryServices;
